import { render } from "./ModalQuotationDetailSale.vue?vue&type=template&id=59ab9d5b&scoped=true"
import script from "./ModalQuotationDetailSale.vue?vue&type=script&lang=js"
export * from "./ModalQuotationDetailSale.vue?vue&type=script&lang=js"

import "./ModalQuotationDetailSale.vue?vue&type=style&index=0&id=59ab9d5b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ab9d5b"]])

export default __exports__